import styled from 'styled-components'

export const Wrapper = styled.div`
  z-index: 1;

  flex: 1;

  display: flex;
  flex-direction: column;

  margin: 18px;
  margin-left: 0;

  height: calc(100% - 38px);

  background: #f9f9f9;
  border-radius: 32px;

  overflow: hidden;
`

export const Container = styled.main`
  height: 100%;
  padding: 18px 54px 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: auto;

  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.06);
    opacity: 0;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.18);
    border-radius: 3px;
  }
`
